
import { BiSearch } from "react-icons/bi";

export default function EmployeeSearch({ searchQuery, setSearchQuery }) {
  return (
    <div>
      <div className="flex items-center justify-between bg-white px-2.5 border border-[#e0e0e0] rounded-lg h-10 cursor-pointer">
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="bg-transparent border-0 outline-none text-medium-dark-gray capitalize placeholder:text-[#c4c4c4] text-sm"
        />
        <span>
          <BiSearch className="font-icon" />
        </span>
      </div>
    </div>
  );
}
